/*
  Blog tutorial lightbox.
  Click any image inside .blog-tutorial .hh-content (step figures, gallery,
  comparison shots, tables, illustrations) to open a fullscreen view.
  Skips images wrapped in <a> tags (e.g., the Pinterest CTA), and any image
  with [data-no-lightbox].
  Close on backdrop click, close button, or Escape key.
*/
(function () {
  if (typeof document === 'undefined') return;

  function ensureLightbox() {
    var lb = document.getElementById('bt-lightbox');
    if (lb) return lb;
    lb = document.createElement('div');
    lb.id = 'bt-lightbox';
    lb.className = 'bt-lightbox';

    var closeBtn = document.createElement('button');
    closeBtn.className = 'bt-lightbox__close';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.textContent = '×'; // × multiplication sign

    var img = document.createElement('img');
    img.alt = '';

    lb.appendChild(closeBtn);
    lb.appendChild(img);
    document.body.appendChild(lb);
    return lb;
  }

  // Shopify CDN images often have a "_NNNxNNN" size suffix that returns a
  // resized thumbnail. Strip it to load the original full-resolution image
  // for the lightbox view.
  function highResUrl(url) {
    if (!url) return url;
    return url.replace(/_\d+x\d+(\.[a-zA-Z]+)([?#]|$)/i, '$1$2');
  }

  function openLightbox(srcImg) {
    var lb = ensureLightbox();
    var img = lb.querySelector('img');
    var src = highResUrl(srcImg.currentSrc || srcImg.src);
    // Hide image until the new src has actually loaded — prevents the previous
    // image from flashing briefly when opening a new one.
    img.style.opacity = '0';
    img.alt = srcImg.alt || '';
    img.onload = function () {
      img.style.opacity = '1';
      img.onload = null;
    };
    img.src = src;
    lb.classList.add('open');
    document.body.classList.add('bt-lightbox-open');
  }

  function closeLightbox() {
    var lb = document.getElementById('bt-lightbox');
    if (!lb) return;
    lb.classList.remove('open');
    document.body.classList.remove('bt-lightbox-open');
    // Clear the src so the old image doesn't flash when the lightbox reopens
    // with a different image. Use removeAttribute (not src='') because setting
    // src to empty string triggers a "blocked image" warning in some browsers.
    var img = lb.querySelector('img');
    if (img) {
      img.removeAttribute('src');
      img.style.opacity = '0';
    }
  }

  document.addEventListener('click', function (e) {
    // Close button or backdrop click
    var lb = e.target.closest('.bt-lightbox');
    if (lb) {
      if (
        e.target.classList.contains('bt-lightbox__close') ||
        e.target === lb
      ) {
        closeLightbox();
      }
      return;
    }

    // Article image click → open lightbox
    var img = e.target.closest('.blog-tutorial .hh-content img');
    if (!img) return;
    if (img.closest('a')) return; // linked image (Pinterest, product, etc.) — let the link work
    if (img.hasAttribute('data-no-lightbox')) return;
    if (img.naturalWidth && img.naturalWidth < 200) return; // skip tiny inline images
    e.preventDefault();
    openLightbox(img);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeLightbox();
  });
})();
